import { Component, OnInit } from '@angular/core';
import { BackendService } from 'app/shared/backend.service';
import { AuthService } from 'app/shared/auth.service';
import CONFIG from 'config';
import { FormGroup, FormBuilder,FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from 'app/notification/notification.service';
import {DatePipe} from '@angular/common';
//import { AUG } from '@angular/material';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { stringify } from 'querystring';
import { AppService } from 'app/app.service';

@Component({
  selector: 'app-accountdisbursement',
  templateUrl: './accountdisbursement.component.html',
  styleUrls: ['./accountdisbursement.component.scss'],
  providers:[DatePipe]
})
export class AccountdisbursementComponent implements OnInit 
{


  maxDate=new Date(new Date().setDate(new Date().getDate()+7));
  minDate = new Date(new Date().setDate(new Date().getDate()+1));
  dateFilter = (d: Date): boolean => 
  {
    const day = d.getDay();
    const month=d.getMonth();
    //this.weekOff(d.getDay());
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6 ;
  }
  weekOff(day)
  {
    console.log(day);
    if(day==5)
        this.date=new FormControl(new Date(new Date().setDate(new Date().getDate()+3)));
     else if (day==6)
      this.date=new FormControl(new Date(new Date().setDate(new Date().getDate()+2)));
    else 
        this.date=new FormControl(new Date(new Date().setDate(new Date().getDate()+1)));
  }
  //dateFilter = (date: Date) => date.getMonth() % 2 == 1 && date.getDate() % 2 == 0;
  addholidaycount:number=0;
  increament:number=0;;
  //maxDateTest=new Date(new Date().setDate(new Date().getDate()+(6+this.addholidaycount)));
  date=new FormControl(new Date(new Date().setDate(new Date().getDate()+1)));
  currentday:number;
  splitlist:string;
  returnDateValue:any;  

  // dateFilter = (d: Date): boolean => 
  // {
    
   
  //   const year=d.getFullYear();
  //   const date=d.getDate();
  //   const day = d.getDay();
  //   const month=d.getMonth()+1;

  //   //console.log(year,date,day,month);
  //   //console.log(this.holidayList);
  //   const increamentday=6;
  //   for(let i=0;i<=this.holidayList.length-1;i++)
  //   {

  //   //  let mindate= new Date(new Date().setDate(new Date().getDate()));
  //   //  const checkdate=this.holidayList[i];
  //   //  let mindate2=this._datepipe.transform(d.getDate().toString(),"MM/dd/yyyy");
  //   //   console.log(mindate2); 
  //   //   let value= this.holidayList.filter(x=>x[i]==mindate2);
  //     const checkdate=this.holidayList[i];
  //     const checkdatelist=checkdate.split(" ");
  //     this.returnDateValue=checkdatelist[0];
      

  //     this.splitlist=checkdate.split("/");
  //     const m=parseInt(this.splitlist[0]);
  //     const ford=parseInt(this.splitlist[1]);
  //     const y=parseInt(this.splitlist[2]);
  //     //console.log(y,d,m);
  //    // console.log(year,date,month);

  //     // if(d.getDate()== ford)
  //     // { 
  //     //   console.log(d.getDate(),ford);
  //     //   this.increament=this.increament+1;
  //     //   this.defaultDateAfterHoliday(this.increament);
  //     //   console.log(this.increament);
  //     // }
  //     this.increament=0;
  //     console.log(month,m);
  // if(month==m)
  //   {
  //     if(date==ford)
  //     {
  //       if(month==m)
  //       {
  //         if(year==y)
  //         {
  //           console.log("condition");
  //           this.addholidaycount=this.addholidaycount+1;
  //           console.log(this.addholidaycount);
  //           this.dateField(this.addholidaycount);
  //           console.log("After Condition");
  //           //break;
            
  //         }
  //        // this.defaultDateAfterHoliday(this.addholidaycount);
  //       }
  //     }
  //   }
  //   else
  //   {
  //     console.log("else");
  //   }
  //     this.addholidaycount=0;
  //    // console.log(this.addholidaycount);
  // }
  //   // for(let i=0;i<=this.holidayList.length-1;i++)
  //   // {
  //   //   const checkdate=this.holidayList[i];
 
  //   //   if(date==checkdate)
  //   //   {

  //   //   }

  //   // }
  //   console.log(this.returnDateValue);
  //   //console.log(value);
  //   // Prevent Saturday and Sunday from being selected.
  //   return day !== 0 && day !== 6  && month/date/year!== this.returnDateValue  ;
  // }
  // checkdateList:any;
  // conditionOnHolidays(d:any)
  // {
  //   for(let i=0;i<=this.holidayList.length-1;i++)
  //   {
  //      const checkdate=this.holidayList[i];
  //     console.log(checkdate.split(" "));
  //     this.checkdateList=checkdate[0];
  //     console.log(this.checkdateList);
  //   }
    
  //   return this.checkdateList;
  // }




  //  defaultDateAfterHoliday(value)
  // {
  //   this.date=new FormControl(new Date(new Date().setDate(new Date().getDate()+value)));
  // }

  

  // dateField(value)
  // {
  // this.maxDateTest=new Date(new Date().setDate(new Date().getDate()+(6+value)));
  // this.date=new FormControl(new Date(new Date().setDate(new Date().getDate()+value)));

  // }
  
  //date=new FormControl(new Date(new Date().setDate(new Date().getDate()+6)));
  
  fromAccount:any;
  paymentMethods:any;
  payee:any;
  selectedAccBalanceList:any;
  selectedAccBalance:string;
  operatingAccountNo:any;
  selectedCurrency:any;
  withdrawData:FormGroup;
  payeeName:any;
  payeeAddress:any;
  currentlessthanfrom:boolean=false;
  payMethodselectedvalue:any;
  selectedValue:any;
  description:any;
  payAmountFrom:any;
  today:any;
  holidayList:any;
  maxDateTest:any;
  //dateFilter:any;
  //date:any;

  constructor(public _backendService:BackendService,
              public authService:AuthService,
              public _formBuilder:FormBuilder,
              public _router:Router,
              public _notificationService:NotificationService,
              public _datepipe:DatePipe,
              public _appService:AppService
              ) 
  { 

  }
//   async delay(ms: number) {
//     await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("fired"));
// }

  ngOnInit() 
  {  
   
    this.today=this._datepipe.transform(Date.now().toString(),"MM/dd/yyyy");
    //console.log(this.today);
    this.gettingWithdrawData();
    this.weekOff(new Date().getDay());
    this.withdrawData=this._formBuilder.group({
      'paymentDate':[''],
      'operatingAcc':[''],
      'fromCurrency':[''],
      'product':[''],
      'accountNo':[''],
      'currentBalance':[''],
      //'paymentAmount':[''],
      'paymentMethods':[''],
      'amountFrom':['',Validators.required],
      'payee':['',Validators.required],
      'comments':['',Validators.required],
    });
    this._appService.setUserLoggedIn(true);
  }
  ngDoCheck()
  {
    //this.maxDateTest=new Date(new Date().setDate(new Date().getDate()+(6+this.addholidaycount)));
    //this.dateFilter(new Date(new Date().setDate(new Date().getDate())));
  }

  clear()
  {
    this.selectedCurrency='';
    this.currentlessthanfrom=false;

  }

  gettingWithdrawData()
  {
    this._backendService.getData(`${CONFIG.getWithdrawData}/${this.authService.CustomerID}`)
                                .subscribe(response=>{console.log(response);
                                        this.fromAccount=response['fromAccount'];
                                        this.paymentMethods=response['paymentMethods'];
                                        //this.payee=response['customerDetails'];
                                        //this.holidayList=response['holidayList'];
                                        //this.payeeName=this.payee.customerName;
                                        //this.payeeAddress=this.payee.customerAddress;
                                       

    });
   
  }
  onSelectedOperatingAcc(value)
  {
    //console.log(value);
    this.selectedAccBalanceList=this.fromAccount.filter(x=>x.accountingBook==value);
    this.selectedAccBalance=this.selectedAccBalanceList[0].currentBalance;
    this.operatingAccountNo=this.selectedAccBalanceList[0].accountNo;
    this.selectedCurrency=this.selectedAccBalanceList[0].accountCurrency;
    this.description=this.selectedAccBalanceList[0].product;
    //this.payeeName=this.payee.customerName;
    //this.payeeAddress=this.payee.customerAddress;
    //console.log(this.payeeName,this.payeeAddress);

  }

  payAmount(value)
  {
    //console.log(value);
    this.payAmountFrom=value;
    if(parseInt(value) < 0)
    {
      this.currentlessthanfrom = true;
     // console.log( this.currentlessthanfrom );
      return { currentlessthanfrom: true       } 
    }
    else if(parseInt(value) >= parseInt(this.selectedAccBalance))
    {
      this.currentlessthanfrom = true;
     // console.log( this.currentlessthanfrom );
      return { currentlessthanfrom: true       }
    }

    //  if(this.selectedAccBalance >= value)
    //  {
    //   this.currentlessthanfrom = true;
    //   console.log( this.currentlessthanfrom );
    //   return { currentlessthanfrom: true       } 
    //   }
    //   else
    //   {
    //     this.currentlessthanfrom = false;
    //   console.log( this.currentlessthanfrom );
    //   return { currentlessthanfrom: false       }
    //   }

    
    else
    {
      this.currentlessthanfrom = false;
      //console.log( this.currentlessthanfrom );
      return { currentlessthanfrom: false       }
    }
  }
  // payMethods(value)
  // {
  //   // console.log(value);
  //   this.payMethodselectedvalue=value;
  // }
  btnwithdrawSave(Data)
  {
      if(Data.paymentDate=="")
      Data.paymentDate=this._datepipe.transform(this.date.value.toString(),"MM/dd/yyyy");


      Data.paymentDate=this._datepipe.transform(Data.paymentDate.toString(),"MM/dd/yyyy");
      if(parseInt(Data.amountFrom) > parseInt( this.selectedAccBalance))
      {
        this._notificationService.showNotification({ type: 'error', message:"You must correct all errors before proceeding."});
      }
      else if(Data.amountFrom == "" || Data.payee == "" || Data.comments == "")
      {
        this._notificationService.showNotification({ type: 'error', message:"You must correct all errors before proceeding."});
      }
      else
      {
      //console.log(Data);
      Data.accountNo=this.operatingAccountNo;
      Data.currentBalance=this.selectedAccBalance;
      Data.fromCurrency=this.selectedCurrency;
      //Data.payee=this.payeeName+this.payeeAddress;
      //Data.paymentMethods=this.payMethodselectedvalue;
      Data.product=this.description;
      this._backendService.postData(Data,`${CONFIG.getWithdrawData}/${this.authService.CustomerID}`)
                          .subscribe(response=>{console.log(response);
                            if (response['result']) 
                            {
                              this._notificationService.showNotification({ type: 'success', message: response['msg'] });
                            }
                            else
                            {
                              this._notificationService.showNotification({ type: 'error', message: response['msg'] });
                            }
                            this._router.navigate(['/dashboard']);
                          });
                        }
      
  }
  cancel()
  {
    this._router.navigate(['/dashboard']);
  }
}
